import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInSeconds,
} from "date-fns";
import { Oval } from "react-loader-spinner";

export const userNameLimit = 40;

export const scopeTitleLimit = 60;

export const orgNameLimit = 30;

export const emailLimit = 80;

export const calculateDaysDifference = (createdDate) => {
  if (createdDate) {
    const createdDateObj = new Date(createdDate);
    const currentDate = new Date();
    const diffInSeconds = differenceInSeconds(currentDate, createdDateObj);
    const diffInMinutes = differenceInMinutes(currentDate, createdDateObj);
    const diffInHours = differenceInHours(currentDate, createdDateObj);
    const diffInDays = differenceInDays(currentDate, createdDateObj);
    const diffInMonths = differenceInMonths(currentDate, createdDateObj);

    if (diffInSeconds < 60) {
      return "Just now";
    } else if (diffInMinutes < 60) {
      return diffInMinutes === 1
        ? "1 minute ago"
        : `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return diffInHours === 1 ? "1 hour ago" : `${diffInHours} hours ago`;
    } else if (diffInMonths > 0) {
      return diffInMonths === 1 ? "1 month ago" : `${diffInMonths} months ago`;
    } else {
      return diffInDays === 1 ? "1 day ago" : `${diffInDays} days ago`;
    }
  } else {
    return "";
  }
};

export const extractHeadings = (htmlContent) => {
  const div = document.createElement("div");
  div.innerHTML = htmlContent;

  const headings = div.querySelectorAll("h1, h2, h3, h4, h5, h6");

  let contentHeading = Array.from(headings).map((heading, index) => {
    const id =
      heading.id ||
      `heading-${index}-${heading.innerText
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")}`;
    heading.id = id; // Assign the generated ID to the heading

    return {
      text: heading.innerText,
      level: parseInt(heading.tagName.replace("H", "")),
      id: id,
    };
  });
  return contentHeading.filter((x) => x.text != "");
};

export const updateHeadingsInHtml = (htmlContent) => {
  const div = document.createElement("div");
  div.innerHTML = htmlContent;

  const headings = div.querySelectorAll("h1, h2, h3, h4, h5, h6");

  Array.from(headings).forEach((heading, index) => {
    const id =
      heading.id ||
      `heading-${index}-${heading.innerText
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")}`;
    heading.id = id;
  });

  return div.innerHTML;
};

export const scrollToId = (event, id) => {
  event.preventDefault();
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

//Validate the email
export const validateEmail = (email, stateUpdate) => {
  let message = "";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*$/;
  const consecutiveDotsRegex = /\.\./;
  const trimmedEmail = email?.trim();
  const isValid =
    emailRegex.test(trimmedEmail) && !consecutiveDotsRegex.test(trimmedEmail);

  if (!isValid) {
    if (!trimmedEmail.trim()) {
      message = "Email Address is required.";
    } else {
      message = "Please enter a valid email address.";
    }
    // return false;
  }
  return { isValid, message };
};

// Validate text input fields
export const validateTextInput = (value) => {
  const trimmedValue = value?.trim();
  const startsWithInvalidChar = /^[^a-zA-Z]/.test(trimmedValue);
  const isValid =
    trimmedValue && trimmedValue.length >= 2 && /[a-zA-Z]/.test(trimmedValue);
  //  &&
  // !startsWithInvalidChar;

  return {
    isValid,
    cleanedValue: trimmedValue,
    message: isValid
      ? "Valid input"
      : // : startsWithInvalidChar
      // ? "Field should not start with a number or special character."
      !(trimmedValue?.length >= 2)
      ? "Please enter at least 2 characters."
      : "Please ensure the field contains alphabets.",
  };
};

export const validatePhoneNumber = (phoneNumber) => {
  let message = "";
  let isValid = true;

  // if (!phoneNumber || phoneNumber.length === 0) {
  //   message = "Phone Number is required.";
  //   isValid = false;
  // } else
  if (
    phoneNumber &&
    phoneNumber.length > 0 &&
    (phoneNumber.length < 10 || phoneNumber.length > 15)
  ) {
    message = "Phone Number should be 10-15 digits long.";
    isValid = false;
  }

  return { isValid, message };
};

export const getformattedPhoneNumber = (value) => {
  if (!value) return "";

  // Preserve + if it's at the beginning
  const hasCountryCode = value.startsWith("+");
  const numericInput = value.replace(/[^0-9]/g, "").slice(0, 14); // Keep only numbers

  let formattedNumber = numericInput;

  if (numericInput.length > 3 && numericInput.length <= 6) {
    formattedNumber = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3)}`;
  } else if (numericInput.length > 6) {
    formattedNumber = `(${numericInput.slice(0, 3)}) ${numericInput.slice(
      3,
      6
    )}-${numericInput.slice(6, 14)}`;
  }

  return hasCountryCode ? `+${formattedNumber}` : formattedNumber;
};

// Function to get the plain numeric phone number for API
export const getPlainPhoneNumber = (phoneNumber) => {
  let plainNumber = '';
  // Remove formatting from the phone number
  plainNumber = phoneNumber?.replace(/[^0-9]/g, '');
  return plainNumber;
};

// Common loader for the button loading.
export const selectLoader = (size = 20) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // padding: '10px'
    }}
  >
    <Oval
      height={size}
      width={size}
      color="#ffff"
      ariaLabel="oval-loading"
      wrapperStyle={{}}
      wrapperClass=""
    />
  </div>
);
